import React from 'react'
import { TextField } from '@diversioteam/diversio-ds'

import { FieldWrapper } from './../FieldWrapper'
import { ShortAnswerInactive } from './shortAnswerInactive'
import { ShortAnswerProps } from './shortAnswer.types'
import * as S from './../fields.styles'

export const ShortAnswer = ({
    item,
    isActive,
    isDeleteElementButtonDisabled,
    onAddElement,
    onChangeElementValue,
    onDeleteElement,
    onToggleRequired,
    onChangeElementType,
    onDuplicateElement,
    onChangeActiveElement,
    previewMode,
}: ShortAnswerProps) => {
    if (previewMode) {
        return <ShortAnswerInactive item={item} previewMode={previewMode} />
    }

    if (!isActive) {
        return <ShortAnswerInactive item={item} onClick={() => onChangeActiveElement(item.id)} />
    }

    return (
        <FieldWrapper
            item={item}
            isActive={isActive}
            isDeleteElementButtonDisabled={isDeleteElementButtonDisabled}
            onAddElement={onAddElement}
            onChangeElementValue={onChangeElementValue}
            onDeleteElement={onDeleteElement}
            onToggleRequired={onToggleRequired}
            onChangeElementType={onChangeElementType}
            onDuplicateElement={onDuplicateElement}
            onChangeActiveElement={onChangeActiveElement}
        >
            <S.OptionList>
                <S.OptionRow>
                    <TextField
                        name={`short-answer-${item.id}`}
                        aria-label="Short answer text"
                        placeholder="Short answer text"
                        defaultValue="Short answer text"
                        variant="standard"
                        fullWidth
                        disabled
                    />
                </S.OptionRow>
            </S.OptionList>
        </FieldWrapper>
    )
}
